import { SvgIcon, } from '@material-ui/core';
import React from 'react';

const FilterIcon = (props) => {
  return (
    React.createElement(SvgIcon, { ...props, viewBox: "0 0 12 13"   ,}
      , React.createElement('path', { d: "M8.00023 11.2533C8.0269 11.4533 7.96023 11.6667 7.8069 11.8067C7.5469 12.0667 7.1269 12.0667 6.8669 11.8067L4.19356 9.13333C4.04023 8.98 3.97356 8.77333 4.00023 8.58V5.16667L0.806897 1.08C0.580231 0.793333 0.633564 0.373333 0.920231 0.146667C1.0469 0.0533334 1.1869 0 1.33356 0H10.6669C10.8136 0 10.9536 0.0533334 11.0802 0.146667C11.3669 0.373333 11.4202 0.793333 11.1936 1.08L8.00023 5.16667V11.2533ZM2.69356 1.33333L5.33356 4.70667V8.38667L6.6669 9.72V4.7L9.3069 1.33333H2.69356Z"                                           ,} )
    )
  );
};

export default FilterIcon;
